export const VENDOR_LIST_BASE_PERMISSION_SLUG = 'vendor_list';
export const PROPOSAL_BASE_SHEET_PERMISSION_SLUGS = [
    'traducao',
    'fonte_valid',
    'tabelas',
    'potencia_padrao',
    'info_aquecedor',
    'calc_dados_padrao',
    'eficiencia',
    'calc_pre_ar',
    'calc_tambor_vapor_flamo',
    'calc_tambor_vapor_aqua',
    'calc_tanques_condensado',
    'calc_combustivel',
    'calc_chamine',
    'cidades_brasil',
    'cidades_exterior',
    'tabela_ar_comprimido',
    'tabela_qualidade_agua',
    'combustiveis',
    'sintese_flamo',
    'sintese_aqua_super',
    'sintese_aqua_saturada',
    'sintese_aquecedor',
    'sintese_iggq',
    'sintese_igaq',
    'sintese_icgo',
    'sintese_icgo_aqua',
    'sintese_icaq',
    'sintese_iget',
    // Glossário técnico PT/EN/ES do Tradutor de Proposta (mig 951).
    'glossario_tecnico',
    VENDOR_LIST_BASE_PERMISSION_SLUG,
];
function viewAction(slug) {
    return `visualizar_dados_base_${slug}`;
}
function editAction(slug) {
    return `editar_dados_base_${slug}`;
}
export function canViewProposalBaseSheet(hasPermission, slug) {
    if (!slug)
        return false;
    if (hasPermission('comercial', 'visualizar_dados_base_proposta'))
        return true;
    if (hasPermission('comercial', 'editar_dados_base_proposta'))
        return true;
    if (hasPermission('comercial', viewAction(slug)))
        return true;
    // Editar/excluir a subaba implica poder enxergá-la na UI.
    return (hasPermission('comercial', editAction(slug)) ||
        hasPermission('comercial', `excluir_dados_base_${slug}`));
}
export function canEditProposalBaseSheet(hasPermission, slug) {
    if (!slug)
        return false;
    if (hasPermission('comercial', 'editar_dados_base_proposta'))
        return true;
    return hasPermission('comercial', editAction(slug));
}
export function canViewVendorListBaseTab(hasPermission) {
    return canViewProposalBaseSheet(hasPermission, VENDOR_LIST_BASE_PERMISSION_SLUG);
}
export function canEditVendorListBaseTab(hasPermission) {
    return canEditProposalBaseSheet(hasPermission, VENDOR_LIST_BASE_PERMISSION_SLUG);
}
export const PROPOSAL_BASE_SUB_TAB_VIEW_PERMISSIONS = PROPOSAL_BASE_SHEET_PERMISSION_SLUGS.map(slug => ({
    modulo: 'comercial',
    acao: viewAction(slug),
}));
export const PROPOSAL_BASE_ROUTE_PERMISSIONS = [
    { modulo: 'comercial', acao: 'visualizar_dados_base_proposta' },
    { modulo: 'comercial', acao: 'editar_dados_base_proposta' },
    { modulo: 'comercial', acao: 'excluir_dados_base_proposta' },
    ...PROPOSAL_BASE_SUB_TAB_VIEW_PERMISSIONS,
    ...PROPOSAL_BASE_SHEET_PERMISSION_SLUGS.map(slug => ({
        modulo: 'comercial',
        acao: editAction(slug),
    })),
    ...PROPOSAL_BASE_SHEET_PERMISSION_SLUGS.map(slug => ({
        modulo: 'comercial',
        acao: `excluir_dados_base_${slug}`,
    })),
];
export function canAccessAnyProposalBaseSubTab(hasPermission) {
    if (hasPermission('comercial', 'visualizar_dados_base_proposta'))
        return true;
    if (hasPermission('comercial', 'editar_dados_base_proposta'))
        return true;
    return PROPOSAL_BASE_SHEET_PERMISSION_SLUGS.some(slug => hasPermission('comercial', viewAction(slug)) ||
        hasPermission('comercial', editAction(slug)) ||
        hasPermission('comercial', `excluir_dados_base_${slug}`));
}
export function resolveProposalBaseSheetPermissionSlug(sheet) {
    const explicit = sheet.permissionSlug?.trim();
    if (explicit)
        return explicit;
    const sheetName = sheet.sheetName?.trim();
    if (!sheetName)
        return null;
    return sheetName
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        // CidadesBrasil → Cidades_Brasil (CamelCase / PascalCase)
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
}
